import React from 'react';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../primitives/SMLButton';
import styles from './SMLUpgradeActions.module.scss';

interface SMLUpgradeActionsProps {
  primaryLabel: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
  /** The ghost button beside the CTA — "Not now", "Stay on Free". */
  secondaryLabel?: string;
  onSecondary?: () => void;
  /** Small centred line under the buttons. */
  fineprint?: React.ReactNode;
  linkLabel?: string;
  onLink?: () => void;
}

/** The button row, fine print and link that close every view of the modal. */
const SMLUpgradeActionsComponent: React.FC<SMLUpgradeActionsProps> = ({
  primaryLabel,
  onPrimary,
  primaryDisabled = false,
  secondaryLabel,
  onSecondary,
  fineprint,
  linkLabel,
  onLink,
}) => (
  <>
    <div className={styles.actions}>
      <SMLButton variant="primary" className={styles.cta} disabled={primaryDisabled} onClick={onPrimary}>
        {primaryLabel}
      </SMLButton>
      {secondaryLabel !== undefined && <SMLButton onClick={onSecondary}>{secondaryLabel}</SMLButton>}
    </div>

    {fineprint !== undefined && <p className={styles.fineprint}>{fineprint}</p>}

    {linkLabel !== undefined && (
      <button type="button" className={styles.link} onClick={onLink}>
        {linkLabel}
      </button>
    )}
  </>
);

export const SMLUpgradeActions = TypedMemo(SMLUpgradeActionsComponent);
